import { render } from "./DiscussionV1.vue?vue&type=template&id=e59ef4ec&scoped=true"
import script from "./DiscussionV1.vue?vue&type=script&lang=js"
export * from "./DiscussionV1.vue?vue&type=script&lang=js"

import "./DiscussionV1.vue?vue&type=style&index=0&id=e59ef4ec&lang=sass&scoped=true"
import "./DiscussionV1.vue?vue&type=style&index=1&id=e59ef4ec&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59ef4ec"]])

export default __exports__